export default __webpack_public_path__ + "static/media/telegram-icon-input.564838db.svg";